const StaffsTable = ({ data = [], loading, onEdit }) => {
  if (loading) return <p>Loading staff...</p>;

  return (
    <div className="table-card">
      <div className="table-wrapper">
        <table className="students-table">
          <thead>
            <tr>
              <th>Staff</th>
              <th>Department</th>
              <th>Designation</th>
              <th>Branch</th>
              <th className="text-right">Salary</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <tr key={row.StaffId}>
                <td>
                  <div className="student-cell">
                    <img
                      src={row.StaffProfilePicUrl || "/avatar.png"}
                      alt={row.StaffName}
                    />
                    <span>{row.StaffName}</span>
                  </div>
                </td>
                <td>{row.Department}</td>
                <td>{row.Designation}</td>
                <td>{row.BranchName}</td>
                <td className="text-right">₹{row.Salary}</td>
                <td className="text-center">
                  <button className="action-btn edit" onClick={() => onEdit(row)}>
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffsTable;
